import { ElMessage } from "element-plus";
import { requireLogin } from "@/utils/authGuard";

/**
 * 「加入我的应用」页面混入。
 *
 * 应用广场里的每张卡片都提供「＋」按钮，点击后把内容加入个人板块
 * （我的AI工作台 → 应用），再次点击可移出。
 *
 * @param {string} type 内容类型：tool / agent / case / prompt / web / software / request
 * @returns {object} Vue mixin
 */
export default function myAppsMixin(type) {
  return {
    data() {
      return {
        /** 当前用户已加入的内容 id */
        myAppIds: [],
        /** 正在提交的内容 id，防重复点击 */
        myAppBusy: "",
      };
    },
    created() {
      this.loadMyAppIds();
    },
    methods: {
      async loadMyAppIds() {
        // 未登录时不请求，避免无谓的 401 弹窗
        if (!localStorage.getItem("token")) return;
        try {
          const res = await this.$axios({ url: `fav/ids/${type}` });
          if (res.code === 200 && Array.isArray(res.data)) {
            this.myAppIds = res.data;
          }
        } catch (e) {
          /* 未登录/网络异常时静默 */
        }
      },
      /** 是否已在我的应用里 */
      inMyApps(id) {
        return this.myAppIds.indexOf(id) >= 0;
      },
      /** 加入 / 移出我的应用 */
      toggleMyApp(id) {
        if (!requireLogin(this, "加入我的应用")) return;
        if (!id || this.myAppBusy) return;
        const added = this.inMyApps(id);
        this.myAppBusy = id;
        this.$axios({
          url: `fav/${type}/${id}`,
          method: added ? "DELETE" : "GET",
        })
          .then((res) => {
            if (res.code !== 200) {
              ElMessage.error(res.msg || "操作失败");
              return;
            }
            if (added) {
              this.myAppIds = this.myAppIds.filter((x) => x !== id);
              ElMessage.success("已从我的应用移出");
            } else {
              this.myAppIds = [...this.myAppIds, id];
              ElMessage.success("已加入我的应用");
            }
          })
          .catch(() => ElMessage.error("操作失败，请稍后重试"))
          .finally(() => {
            this.myAppBusy = "";
          });
      },
    },
  };
}
